"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/**
 * ProductArea Icon Component
 *
 * Tree-shakeable icon component for product area indicators.
 *
 * @example
 * ```tsx
 * import ProductArea from '@insided/destination/icons/ProductArea'
 *
 * <ProductArea width={16} height={16} />
 * ```
 */
var ProductArea = function ProductArea(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Product Area",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M6.90001 10.8L12 2.39999L17.1 10.8H6.90001ZM17.4 21.6C16.2333 21.6 15.2417 21.1917 14.425 20.375C13.6083 19.5583 13.2 18.5667 13.2 17.4C13.2 16.2333 13.6083 15.2417 14.425 14.425C15.2417 13.6083 16.2333 13.2 17.4 13.2C18.5667 13.2 19.5583 13.6083 20.375 14.425C21.1917 15.2417 21.6 16.2333 21.6 17.4C21.6 18.5667 21.1917 19.5583 20.375 20.375C19.5583 21.1917 18.5667 21.6 17.4 21.6ZM3.60001 21V13.8H10.8V21H3.60001ZM17.3943 19.8C18.0648 19.8 18.6333 19.5686 19.1 19.1057C19.5667 18.6427 19.8 18.0761 19.8 17.4057C19.8 16.7352 19.5686 16.1667 19.1058 15.7C18.6428 15.2333 18.0761 15 17.4058 15C16.7353 15 16.1667 15.2314 15.7 15.6942C15.2333 16.1572 15 16.7239 15 17.3942C15 18.0647 15.2314 18.6333 15.6943 19.1C16.1573 19.5667 16.7239 19.8 17.3943 19.8ZM5.40001 19.2H9.00001V15.6H5.40001V19.2ZM10.1 8.99999H13.9L12 5.87499L10.1 8.99999Z",
    fill: "currentColor"
  }));
};

var _default = ProductArea;
exports.default = _default;